import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { ClaimService, ErrorStateService, GuidService, LoggingService } from '@app-core';
import { Claim } from '@app-models';
import { Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ClaimResolverEmployer implements Resolve<Claim | null> {
    private readonly claimService: ClaimService = inject(ClaimService);
    private readonly errorStateService: ErrorStateService = inject(ErrorStateService);
    private readonly router: Router = inject(Router);
    private readonly guidService: GuidService = inject(GuidService);

    constructor() {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Claim | null> {
        const GUID = route.queryParamMap.get('guid');
        LoggingService.log('ClaimResolverEmployer::resolve:', GUID);

        if (this.errorStateService.hasProgressEventErrorOccurred()) {
            // If a progress event error occurred, navigate to the error page and return null
            this.router.navigate(['/error'], { skipLocationChange: true });
            return of(null);
        } else if (!GUID) {
            this.router.navigate(['/not-found'], { skipLocationChange: true });
            return of(null);
        }

        this.guidService.setGuid(GUID);
        return this.claimService.getEmployerClaim(GUID);
    }
}
